import { IFINotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import IFINotificationsProvider, {
  useIFINotificationsContext,
} from './IFINotificationsContext'
import ViewIFINotificationEvent from './components/ViewIFINotificationEvent'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import { useEdit } from './hooks/useEdit'

const Notifications: React.VFC = () => {
  const { loading, refetch } = useIFINotificationsContext()
  return (
    <CIMSNotifications
      events={IFINotificationEvent.values}
      edit={useEdit()}
      onReload={refetch}
      view={<ViewIFINotificationEvent />}
      loading={loading}
    />
  )
}

const IFINotifications: React.VFC = () => {
  return (
    <RecipientsSelectProvider>
      <IFINotificationsProvider>
        <Notifications />
      </IFINotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default IFINotifications
